import { render, staticRenderFns } from "./joinUsDetail.vue?vue&type=template&id=8c086316&scoped=true&"
import script from "./joinUsDetail.vue?vue&type=script&lang=js&"
export * from "./joinUsDetail.vue?vue&type=script&lang=js&"
import style0 from "./joinUsDetail.vue?vue&type=style&index=0&id=8c086316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c086316",
  null
  
)

export default component.exports